var cov_21a5ajomj3 = function () {
  var path = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Form/Form.tsx",
      hash = "c43ebcb1fdebd922ed663bb02c98efb8350e7470",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Form/Form.tsx",
    statementMap: {
      "0": {
        start: {
          line: 13,
          column: 19
        },
        end: {
          line: 13,
          column: 31
        }
      },
      "1": {
        start: {
          line: 14,
          column: 21
        },
        end: {
          line: 18,
          column: 1
        }
      },
      "2": {
        start: {
          line: 41,
          column: 4
        },
        end: {
          line: 41,
          column: 16
        }
      },
      "3": {
        start: {
          line: 43,
          column: 4
        },
        end: {
          line: 43,
          column: 50
        }
      },
      "4": {
        start: {
          line: 44,
          column: 4
        },
        end: {
          line: 44,
          column: 52
        }
      },
      "5": {
        start: {
          line: 45,
          column: 4
        },
        end: {
          line: 45,
          column: 50
        }
      },
      "6": {
        start: {
          line: 47,
          column: 4
        },
        end: {
          line: 47,
          column: 23
        }
      },
      "7": {
        start: {
          line: 48,
          column: 4
        },
        end: {
          line: 48,
          column: 35
        }
      },
      "8": {
        start: {
          line: 50,
          column: 4
        },
        end: {
          line: 71,
          column: 5
        }
      },
      "9": {
        start: {
          line: 51,
          column: 22
        },
        end: {
          line: 51,
          column: 49
        }
      },
      "10": {
        start: {
          line: 52,
          column: 22
        },
        end: {
          line: 52,
          column: 49
        }
      },
      "11": {
        start: {
          line: 53,
          column: 32
        },
        end: {
          line: 53,
          column: 87
        }
      },
      "12": {
        start: {
          line: 54,
          column: 41
        },
        end: {
          line: 54,
          column: 80
        }
      },
      "13": {
        start: {
          line: 56,
          column: 8
        },
        end: {
          line: 56,
          column: 40
        }
      },
      "14": {
        start: {
          line: 59,
          column: 8
        },
        end: {
          line: 66,
          column: 9
        }
      },
      "15": {
        start: {
          line: 59,
          column: 26
        },
        end: {
          line: 59,
          column: 45
        }
      },
      "16": {
        start: {
          line: 61,
          column: 27
        },
        end: {
          line: 61,
          column: 67
        }
      },
      "17": {
        start: {
          line: 62,
          column: 10
        },
        end: {
          line: 62,
          column: 39
        }
      },
      "18": {
        start: {
          line: 62,
          column: 24
        },
        end: {
          line: 62,
          column: 39
        }
      },
      "19": {
        start: {
          line: 64,
          column: 10
        },
        end: {
          line: 64,
          column: 83
        }
      },
      "20": {
        start: {
          line: 64,
          column: 35
        },
        end: {
          line: 64,
          column: 83
        }
      },
      "21": {
        start: {
          line: 65,
          column: 10
        },
        end: {
          line: 65,
          column: 40
        }
      },
      "22": {
        start: {
          line: 65,
          column: 24
        },
        end: {
          line: 65,
          column: 40
        }
      },
      "23": {
        start: {
          line: 69,
          column: 8
        },
        end: {
          line: 69,
          column: 26
        }
      },
      "24": {
        start: {
          line: 75,
          column: 24
        },
        end: {
          line: 75,
          column: 34
        }
      },
      "25": {
        start: {
          line: 76,
          column: 4
        },
        end: {
          line: 82,
          column: 5
        }
      },
      "26": {
        start: {
          line: 77,
          column: 6
        },
        end: {
          line: 81,
          column: 7
        }
      },
      "27": {
        start: {
          line: 78,
          column: 8
        },
        end: {
          line: 78,
          column: 26
        }
      },
      "28": {
        start: {
          line: 80,
          column: 8
        },
        end: {
          line: 80,
          column: 35
        }
      },
      "29": {
        start: {
          line: 83,
          column: 4
        },
        end: {
          line: 83,
          column: 20
        }
      },
      "30": {
        start: {
          line: 84,
          column: 4
        },
        end: {
          line: 86,
          column: 5
        }
      },
      "31": {
        start: {
          line: 85,
          column: 6
        },
        end: {
          line: 85,
          column: 64
        }
      },
      "32": {
        start: {
          line: 90,
          column: 4
        },
        end: {
          line: 90,
          column: 20
        }
      },
      "33": {
        start: {
          line: 91,
          column: 4
        },
        end: {
          line: 91,
          column: 95
        }
      },
      "34": {
        start: {
          line: 91,
          column: 46
        },
        end: {
          line: 91,
          column: 95
        }
      },
      "35": {
        start: {
          line: 95,
          column: 4
        },
        end: {
          line: 95,
          column: 39
        }
      },
      "36": {
        start: {
          line: 96,
          column: 4
        },
        end: {
          line: 98,
          column: 5
        }
      },
      "37": {
        start: {
          line: 97,
          column: 6
        },
        end: {
          line: 97,
          column: 67
        }
      },
      "38": {
        start: {
          line: 102,
          column: 49
        },
        end: {
          line: 102,
          column: 59
        }
      },
      "39": {
        start: {
          line: 103,
          column: 4
        },
        end: {
          line: 103,
          column: 30
        }
      },
      "40": {
        start: {
          line: 103,
          column: 24
        },
        end: {
          line: 103,
          column: 30
        }
      },
      "41": {
        start: {
          line: 104,
          column: 29
        },
        end: {
          line: 104,
          column: 64
        }
      },
      "42": {
        start: {
          line: 105,
          column: 4
        },
        end: {
          line: 105,
          column: 44
        }
      },
      "43": {
        start: {
          line: 105,
          column: 26
        },
        end: {
          line: 105,
          column: 44
        }
      },
      "44": {
        start: {
          line: 106,
          column: 4
        },
        end: {
          line: 106,
          column: 25
        }
      },
      "45": {
        start: {
          line: 110,
          column: 4
        },
        end: {
          line: 110,
          column: 21
        }
      },
      "46": {
        start: {
          line: 114,
          column: 39
        },
        end: {
          line: 114,
          column: 49
        }
      },
      "47": {
        start: {
          line: 115,
          column: 4
        },
        end: {
          line: 124,
          column: 5
        }
      },
      "48": {
        start: {
          line: 116,
          column: 17
        },
        end: {
          line: 116,
          column: 86
        }
      },
      "49": {
        start: {
          line: 117,
          column: 6
        },
        end: {
          line: 120,
          column: 7
        }
      },
      "50": {
        start: {
          line: 118,
          column: 8
        },
        end: {
          line: 118,
          column: 27
        }
      },
      "51": {
        start: {
          line: 119,
          column: 8
        },
        end: {
          line: 119,
          column: 32
        }
      },
      "52": {
        start: {
          line: 119,
          column: 22
        },
        end: {
          line: 119,
          column: 32
        }
      },
      "53": {
        start: {
          line: 121,
          column: 6
        },
        end: {
          line: 123,
          column: 7
        }
      },
      "54": {
        start: {
          line: 122,
          column: 8
        },
        end: {
          line: 122,
          column: 38
        }
      },
      "55": {
        start: {
          line: 126,
          column: 4
        },
        end: {
          line: 126,
          column: 29
        }
      },
      "56": {
        start: {
          line: 126,
          column: 17
        },
        end: {
          line: 126,
          column: 29
        }
      },
      "57": {
        start: {
          line: 127,
          column: 4
        },
        end: {
          line: 127,
          column: 70
        }
      },
      "58": {
        start: {
          line: 127,
          column: 61
        },
        end: {
          line: 127,
          column: 70
        }
      },
      "59": {
        start: {
          line: 131,
          column: 4
        },
        end: {
          line: 133,
          column: 5
        }
      },
      "60": {
        start: {
          line: 132,
          column: 6
        },
        end: {
          line: 132,
          column: 24
        }
      },
      "61": {
        start: {
          line: 134,
          column: 4
        },
        end: {
          line: 134,
          column: 77
        }
      },
      "62": {
        start: {
          line: 134,
          column: 71
        },
        end: {
          line: 134,
          column: 77
        }
      },
      "63": {
        start: {
          line: 135,
          column: 4
        },
        end: {
          line: 135,
          column: 46
        }
      },
      "64": {
        start: {
          line: 135,
          column: 40
        },
        end: {
          line: 135,
          column: 46
        }
      },
      "65": {
        start: {
          line: 137,
          column: 4
        },
        end: {
          line: 137,
          column: 26
        }
      },
      "66": {
        start: {
          line: 140,
          column: 4
        },
        end: {
          line: 140,
          column: 22
        }
      },
      "67": {
        start: {
          line: 141,
          column: 4
        },
        end: {
          line: 143,
          column: 27
        }
      },
      "68": {
        start: {
          line: 142,
          column: 6
        },
        end: {
          line: 142,
          column: 25
        }
      },
      "69": {
        start: {
          line: 145,
          column: 32
        },
        end: {
          line: 145,
          column: 42
        }
      },
      "70": {
        start: {
          line: 147,
          column: 21
        },
        end: {
          line: 147,
          column: 58
        }
      },
      "71": {
        start: {
          line: 148,
          column: 4
        },
        end: {
          line: 148,
          column: 33
        }
      },
      "72": {
        start: {
          line: 148,
          column: 18
        },
        end: {
          line: 148,
          column: 33
        }
      },
      "73": {
        start: {
          line: 149,
          column: 4
        },
        end: {
          line: 149,
          column: 32
        }
      },
      "74": {
        start: {
          line: 151,
          column: 4
        },
        end: {
          line: 166,
          column: 10
        }
      },
      "75": {
        start: {
          line: 152,
          column: 6
        },
        end: {
          line: 165,
          column: 10
        }
      },
      "76": {
        start: {
          line: 155,
          column: 10
        },
        end: {
          line: 155,
          column: 33
        }
      },
      "77": {
        start: {
          line: 157,
          column: 25
        },
        end: {
          line: 157,
          column: 67
        }
      },
      "78": {
        start: {
          line: 158,
          column: 10
        },
        end: {
          line: 158,
          column: 61
        }
      },
      "79": {
        start: {
          line: 158,
          column: 24
        },
        end: {
          line: 158,
          column: 61
        }
      },
      "80": {
        start: {
          line: 159,
          column: 10
        },
        end: {
          line: 159,
          column: 40
        }
      },
      "81": {
        start: {
          line: 159,
          column: 24
        },
        end: {
          line: 159,
          column: 40
        }
      },
      "82": {
        start: {
          line: 162,
          column: 10
        },
        end: {
          line: 162,
          column: 33
        }
      },
      "83": {
        start: {
          line: 164,
          column: 10
        },
        end: {
          line: 164,
          column: 56
        }
      },
      "84": {
        start: {
          line: 170,
          column: 31
        },
        end: {
          line: 170,
          column: 41
        }
      },
      "85": {
        start: {
          line: 171,
          column: 4
        },
        end: {
          line: 171,
          column: 17
        }
      },
      "86": {
        start: {
          line: 172,
          column: 4
        },
        end: {
          line: 172,
          column: 26
        }
      },
      "87": {
        start: {
          line: 172,
          column: 17
        },
        end: {
          line: 172,
          column: 26
        }
      },
      "88": {
        start: {
          line: 176,
          column: 71
        },
        end: {
          line: 176,
          column: 81
        }
      },
      "89": {
        start: {
          line: 178,
          column: 4
        },
        end: {
          line: 180,
          column: 5
        }
      },
      "90": {
        start: {
          line: 179,
          column: 6
        },
        end: {
          line: 179,
          column: 25
        }
      },
      "91": {
        start: {
          line: 182,
          column: 22
        },
        end: {
          line: 185,
          column: 5
        }
      },
      "92": {
        start: {
          line: 187,
          column: 4
        },
        end: {
          line: 191,
          column: 5
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 40,
            column: 2
          },
          end: {
            line: 40,
            column: 3
          }
        },
        loc: {
          start: {
            line: 40,
            column: 45
          },
          end: {
            line: 72,
            column: 3
          }
        },
        line: 40
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 51,
            column: 16
          },
          end: {
            line: 51,
            column: 17
          }
        },
        loc: {
          start: {
            line: 51,
            column: 22
          },
          end: {
            line: 51,
            column: 49
          }
        },
        line: 51
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 52,
            column: 16
          },
          end: {
            line: 52,
            column: 17
          }
        },
        loc: {
          start: {
            line: 52,
            column: 22
          },
          end: {
            line: 52,
            column: 49
          }
        },
        line: 52
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 53,
            column: 22
          },
          end: {
            line: 53,
            column: 23
          }
        },
        loc: {
          start: {
            line: 53,
            column: 32
          },
          end: {
            line: 53,
            column: 87
          }
        },
        line: 53
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 53,
            column: 78
          },
          end: {
            line: 53,
            column: 79
          }
        },
        loc: {
          start: {
            line: 53,
            column: 84
          },
          end: {
            line: 53,
            column: 86
          }
        },
        line: 53
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 54,
            column: 31
          },
          end: {
            line: 54,
            column: 32
          }
        },
        loc: {
          start: {
            line: 54,
            column: 41
          },
          end: {
            line: 54,
            column: 80
          }
        },
        line: 54
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 55,
            column: 21
          },
          end: {
            line: 55,
            column: 22
          }
        },
        loc: {
          start: {
            line: 55,
            column: 27
          },
          end: {
            line: 57,
            column: 7
          }
        },
        line: 55
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 58,
            column: 14
          },
          end: {
            line: 58,
            column: 15
          }
        },
        loc: {
          start: {
            line: 58,
            column: 39
          },
          end: {
            line: 67,
            column: 7
          }
        },
        line: 58
      },
      "8": {
        name: "(anonymous_8)",
        decl: {
          start: {
            line: 68,
            column: 13
          },
          end: {
            line: 68,
            column: 14
          }
        },
        loc: {
          start: {
            line: 68,
            column: 19
          },
          end: {
            line: 70,
            column: 7
          }
        },
        line: 68
      },
      "9": {
        name: "(anonymous_9)",
        decl: {
          start: {
            line: 74,
            column: 2
          },
          end: {
            line: 74,
            column: 3
          }
        },
        loc: {
          start: {
            line: 74,
            column: 22
          },
          end: {
            line: 87,
            column: 3
          }
        },
        line: 74
      },
      "10": {
        name: "(anonymous_10)",
        decl: {
          start: {
            line: 89,
            column: 2
          },
          end: {
            line: 89,
            column: 3
          }
        },
        loc: {
          start: {
            line: 89,
            column: 56
          },
          end: {
            line: 92,
            column: 3
          }
        },
        line: 89
      },
      "11": {
        name: "(anonymous_11)",
        decl: {
          start: {
            line: 94,
            column: 2
          },
          end: {
            line: 94,
            column: 3
          }
        },
        loc: {
          start: {
            line: 94,
            column: 25
          },
          end: {
            line: 99,
            column: 3
          }
        },
        line: 94
      },
      "12": {
        name: "(anonymous_12)",
        decl: {
          start: {
            line: 101,
            column: 2
          },
          end: {
            line: 101,
            column: 3
          }
        },
        loc: {
          start: {
            line: 101,
            column: 14
          },
          end: {
            line: 107,
            column: 3
          }
        },
        line: 101
      },
      "13": {
        name: "(anonymous_13)",
        decl: {
          start: {
            line: 109,
            column: 2
          },
          end: {
            line: 109,
            column: 3
          }
        },
        loc: {
          start: {
            line: 109,
            column: 35
          },
          end: {
            line: 111,
            column: 3
          }
        },
        line: 109
      },
      "14": {
        name: "(anonymous_14)",
        decl: {
          start: {
            line: 113,
            column: 2
          },
          end: {
            line: 113,
            column: 3
          }
        },
        loc: {
          start: {
            line: 113,
            column: 28
          },
          end: {
            line: 128,
            column: 3
          }
        },
        line: 113
      },
      "15": {
        name: "(anonymous_15)",
        decl: {
          start: {
            line: 130,
            column: 2
          },
          end: {
            line: 130,
            column: 3
          }
        },
        loc: {
          start: {
            line: 130,
            column: 26
          },
          end: {
            line: 167,
            column: 3
          }
        },
        line: 130
      },
      "16": {
        name: "(anonymous_16)",
        decl: {
          start: {
            line: 141,
            column: 15
          },
          end: {
            line: 141,
            column: 16
          }
        },
        loc: {
          start: {
            line: 141,
            column: 21
          },
          end: {
            line: 143,
            column: 5
          }
        },
        line: 141
      },
      "17": {
        name: "(anonymous_17)",
        decl: {
          start: {
            line: 151,
            column: 15
          },
          end: {
            line: 151,
            column: 16
          }
        },
        loc: {
          start: {
            line: 151,
            column: 21
          },
          end: {
            line: 166,
            column: 5
          }
        },
        line: 151
      },
      "18": {
        name: "(anonymous_18)",
        decl: {
          start: {
            line: 154,
            column: 14
          },
          end: {
            line: 154,
            column: 15
          }
        },
        loc: {
          start: {
            line: 154,
            column: 20
          },
          end: {
            line: 160,
            column: 9
          }
        },
        line: 154
      },
      "19": {
        name: "(anonymous_19)",
        decl: {
          start: {
            line: 161,
            column: 15
          },
          end: {
            line: 161,
            column: 16
          }
        },
        loc: {
          start: {
            line: 161,
            column: 22
          },
          end: {
            line: 165,
            column: 9
          }
        },
        line: 161
      },
      "20": {
        name: "(anonymous_20)",
        decl: {
          start: {
            line: 169,
            column: 2
          },
          end: {
            line: 169,
            column: 3
          }
        },
        loc: {
          start: {
            line: 169,
            column: 16
          },
          end: {
            line: 173,
            column: 3
          }
        },
        line: 169
      },
      "21": {
        name: "(anonymous_21)",
        decl: {
          start: {
            line: 175,
            column: 2
          },
          end: {
            line: 175,
            column: 3
          }
        },
        loc: {
          start: {
            line: 175,
            column: 11
          },
          end: {
            line: 192,
            column: 3
          }
        },
        line: 175
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 58,
            column: 15
          },
          end: {
            line: 58,
            column: 34
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 58,
            column: 30
          },
          end: {
            line: 58,
            column: 34
          }
        }],
        line: 58
      },
      "1": {
        loc: {
          start: {
            line: 59,
            column: 8
          },
          end: {
            line: 66,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 59,
            column: 8
          },
          end: {
            line: 66,
            column: 9
          }
        }, {
          start: {
            line: 59,
            column: 8
          },
          end: {
            line: 66,
            column: 9
          }
        }],
        line: 59
      },
      "2": {
        loc: {
          start: {
            line: 62,
            column: 10
          },
          end: {
            line: 62,
            column: 39
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 62,
            column: 10
          },
          end: {
            line: 62,
            column: 39
          }
        }, {
          start: {
            line: 62,
            column: 10
          },
          end: {
            line: 62,
            column: 39
          }
        }],
        line: 62
      },
      "3": {
        loc: {
          start: {
            line: 64,
            column: 10
          },
          end: {
            line: 64,
            column: 83
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 64,
            column: 10
          },
          end: {
            line: 64,
            column: 83
          }
        }, {
          start: {
            line: 64,
            column: 10
          },
          end: {
            line: 64,
            column: 83
          }
        }],
        line: 64
      },
      "4": {
        loc: {
          start: {
            line: 65,
            column: 10
          },
          end: {
            line: 65,
            column: 40
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 65,
            column: 10
          },
          end: {
            line: 65,
            column: 40
          }
        }, {
          start: {
            line: 65,
            column: 10
          },
          end: {
            line: 65,
            column: 40
          }
        }],
        line: 65
      },
      "5": {
        loc: {
          start: {
            line: 76,
            column: 4
          },
          end: {
            line: 82,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 76,
            column: 4
          },
          end: {
            line: 82,
            column: 5
          }
        }, {
          start: {
            line: 76,
            column: 4
          },
          end: {
            line: 82,
            column: 5
          }
        }],
        line: 76
      },
      "6": {
        loc: {
          start: {
            line: 77,
            column: 6
          },
          end: {
            line: 81,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 77,
            column: 6
          },
          end: {
            line: 81,
            column: 7
          }
        }, {
          start: {
            line: 77,
            column: 6
          },
          end: {
            line: 81,
            column: 7
          }
        }],
        line: 77
      },
      "7": {
        loc: {
          start: {
            line: 84,
            column: 4
          },
          end: {
            line: 86,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 84,
            column: 4
          },
          end: {
            line: 86,
            column: 5
          }
        }, {
          start: {
            line: 84,
            column: 4
          },
          end: {
            line: 86,
            column: 5
          }
        }],
        line: 84
      },
      "8": {
        loc: {
          start: {
            line: 91,
            column: 4
          },
          end: {
            line: 91,
            column: 95
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 91,
            column: 4
          },
          end: {
            line: 91,
            column: 95
          }
        }, {
          start: {
            line: 91,
            column: 4
          },
          end: {
            line: 91,
            column: 95
          }
        }],
        line: 91
      },
      "9": {
        loc: {
          start: {
            line: 96,
            column: 4
          },
          end: {
            line: 98,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 96,
            column: 4
          },
          end: {
            line: 98,
            column: 5
          }
        }, {
          start: {
            line: 96,
            column: 4
          },
          end: {
            line: 98,
            column: 5
          }
        }],
        line: 96
      },
      "10": {
        loc: {
          start: {
            line: 103,
            column: 4
          },
          end: {
            line: 103,
            column: 30
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 103,
            column: 4
          },
          end: {
            line: 103,
            column: 30
          }
        }, {
          start: {
            line: 103,
            column: 4
          },
          end: {
            line: 103,
            column: 30
          }
        }],
        line: 103
      },
      "11": {
        loc: {
          start: {
            line: 104,
            column: 29
          },
          end: {
            line: 104,
            column: 64
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 104,
            column: 49
          },
          end: {
            line: 104,
            column: 59
          }
        }, {
          start: {
            line: 104,
            column: 62
          },
          end: {
            line: 104,
            column: 64
          }
        }],
        line: 104
      },
      "12": {
        loc: {
          start: {
            line: 105,
            column: 4
          },
          end: {
            line: 105,
            column: 44
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 105,
            column: 4
          },
          end: {
            line: 105,
            column: 44
          }
        }, {
          start: {
            line: 105,
            column: 4
          },
          end: {
            line: 105,
            column: 44
          }
        }],
        line: 105
      },
      "13": {
        loc: {
          start: {
            line: 115,
            column: 4
          },
          end: {
            line: 124,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 115,
            column: 4
          },
          end: {
            line: 124,
            column: 5
          }
        }, {
          start: {
            line: 115,
            column: 4
          },
          end: {
            line: 124,
            column: 5
          }
        }],
        line: 115
      },
      "14": {
        loc: {
          start: {
            line: 117,
            column: 6
          },
          end: {
            line: 120,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 117,
            column: 6
          },
          end: {
            line: 120,
            column: 7
          }
        }, {
          start: {
            line: 117,
            column: 6
          },
          end: {
            line: 120,
            column: 7
          }
        }],
        line: 117
      },
      "15": {
        loc: {
          start: {
            line: 119,
            column: 8
          },
          end: {
            line: 119,
            column: 32
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 119,
            column: 8
          },
          end: {
            line: 119,
            column: 32
          }
        }, {
          start: {
            line: 119,
            column: 8
          },
          end: {
            line: 119,
            column: 32
          }
        }],
        line: 119
      },
      "16": {
        loc: {
          start: {
            line: 121,
            column: 6
          },
          end: {
            line: 123,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 121,
            column: 6
          },
          end: {
            line: 123,
            column: 7
          }
        }, {
          start: {
            line: 121,
            column: 6
          },
          end: {
            line: 123,
            column: 7
          }
        }],
        line: 121
      },
      "17": {
        loc: {
          start: {
            line: 121,
            column: 10
          },
          end: {
            line: 121,
            column: 66
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 121,
            column: 10
          },
          end: {
            line: 121,
            column: 43
          }
        }, {
          start: {
            line: 121,
            column: 47
          },
          end: {
            line: 121,
            column: 66
          }
        }],
        line: 121
      },
      "18": {
        loc: {
          start: {
            line: 126,
            column: 4
          },
          end: {
            line: 126,
            column: 29
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 126,
            column: 4
          },
          end: {
            line: 126,
            column: 29
          }
        }, {
          start: {
            line: 126,
            column: 4
          },
          end: {
            line: 126,
            column: 29
          }
        }],
        line: 126
      },
      "19": {
        loc: {
          start: {
            line: 127,
            column: 4
          },
          end: {
            line: 127,
            column: 70
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 127,
            column: 4
          },
          end: {
            line: 127,
            column: 70
          }
        }, {
          start: {
            line: 127,
            column: 4
          },
          end: {
            line: 127,
            column: 70
          }
        }],
        line: 127
      },
      "20": {
        loc: {
          start: {
            line: 127,
            column: 8
          },
          end: {
            line: 127,
            column: 59
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 127,
            column: 8
          },
          end: {
            line: 127,
            column: 28
          }
        }, {
          start: {
            line: 127,
            column: 32
          },
          end: {
            line: 127,
            column: 59
          }
        }],
        line: 127
      },
      "21": {
        loc: {
          start: {
            line: 131,
            column: 4
          },
          end: {
            line: 133,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 131,
            column: 4
          },
          end: {
            line: 133,
            column: 5
          }
        }, {
          start: {
            line: 131,
            column: 4
          },
          end: {
            line: 133,
            column: 5
          }
        }],
        line: 131
      },
      "22": {
        loc: {
          start: {
            line: 134,
            column: 4
          },
          end: {
            line: 134,
            column: 77
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 134,
            column: 4
          },
          end: {
            line: 134,
            column: 77
          }
        }, {
          start: {
            line: 134,
            column: 4
          },
          end: {
            line: 134,
            column: 77
          }
        }],
        line: 134
      },
      "23": {
        loc: {
          start: {
            line: 134,
            column: 8
          },
          end: {
            line: 134,
            column: 69
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 134,
            column: 8
          },
          end: {
            line: 134,
            column: 9
          }
        }, {
          start: {
            line: 134,
            column: 13
          },
          end: {
            line: 134,
            column: 69
          }
        }],
        line: 134
      },
      "24": {
        loc: {
          start: {
            line: 135,
            column: 4
          },
          end: {
            line: 135,
            column: 46
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 135,
            column: 4
          },
          end: {
            line: 135,
            column: 46
          }
        }, {
          start: {
            line: 135,
            column: 4
          },
          end: {
            line: 135,
            column: 46
          }
        }],
        line: 135
      },
      "25": {
        loc: {
          start: {
            line: 135,
            column: 8
          },
          end: {
            line: 135,
            column: 38
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 135,
            column: 8
          },
          end: {
            line: 135,
            column: 23
          }
        }, {
          start: {
            line: 135,
            column: 27
          },
          end: {
            line: 135,
            column: 38
          }
        }],
        line: 135
      },
      "26": {
        loc: {
          start: {
            line: 148,
            column: 4
          },
          end: {
            line: 148,
            column: 33
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 148,
            column: 4
          },
          end: {
            line: 148,
            column: 33
          }
        }, {
          start: {
            line: 148,
            column: 4
          },
          end: {
            line: 148,
            column: 33
          }
        }],
        line: 148
      },
      "27": {
        loc: {
          start: {
            line: 157,
            column: 25
          },
          end: {
            line: 157,
            column: 67
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 157,
            column: 25
          },
          end: {
            line: 157,
            column: 26
          }
        }, {
          start: {
            line: 157,
            column: 30
          },
          end: {
            line: 157,
            column: 43
          }
        }, {
          start: {
            line: 157,
            column: 47
          },
          end: {
            line: 157,
            column: 67
          }
        }],
        line: 157
      },
      "28": {
        loc: {
          start: {
            line: 158,
            column: 10
          },
          end: {
            line: 158,
            column: 61
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 158,
            column: 10
          },
          end: {
            line: 158,
            column: 61
          }
        }, {
          start: {
            line: 158,
            column: 10
          },
          end: {
            line: 158,
            column: 61
          }
        }],
        line: 158
      },
      "29": {
        loc: {
          start: {
            line: 159,
            column: 10
          },
          end: {
            line: 159,
            column: 40
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 159,
            column: 10
          },
          end: {
            line: 159,
            column: 40
          }
        }, {
          start: {
            line: 159,
            column: 10
          },
          end: {
            line: 159,
            column: 40
          }
        }],
        line: 159
      },
      "30": {
        loc: {
          start: {
            line: 172,
            column: 4
          },
          end: {
            line: 172,
            column: 26
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 172,
            column: 4
          },
          end: {
            line: 172,
            column: 26
          }
        }, {
          start: {
            line: 172,
            column: 4
          },
          end: {
            line: 172,
            column: 26
          }
        }],
        line: 172
      },
      "31": {
        loc: {
          start: {
            line: 178,
            column: 4
          },
          end: {
            line: 180,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 178,
            column: 4
          },
          end: {
            line: 180,
            column: 5
          }
        }, {
          start: {
            line: 178,
            column: 4
          },
          end: {
            line: 180,
            column: 5
          }
        }],
        line: 178
      },
      "32": {
        loc: {
          start: {
            line: 178,
            column: 8
          },
          end: {
            line: 178,
            column: 47
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 178,
            column: 8
          },
          end: {
            line: 178,
            column: 13
          }
        }, {
          start: {
            line: 178,
            column: 17
          },
          end: {
            line: 178,
            column: 22
          }
        }, {
          start: {
            line: 178,
            column: 26
          },
          end: {
            line: 178,
            column: 47
          }
        }],
        line: 178
      },
      "33": {
        loc: {
          start: {
            line: 183,
            column: 29
          },
          end: {
            line: 183,
            column: 64
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 183,
            column: 30
          },
          end: {
            line: 183,
            column: 38
          }
        }, {
          start: {
            line: 183,
            column: 42
          },
          end: {
            line: 183,
            column: 49
          }
        }, {
          start: {
            line: 183,
            column: 54
          },
          end: {
            line: 183,
            column: 64
          }
        }],
        line: 183
      },
      "34": {
        loc: {
          start: {
            line: 183,
            column: 66
          },
          end: {
            line: 183,
            column: 84
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 183,
            column: 66
          },
          end: {
            line: 183,
            column: 72
          }
        }, {
          start: {
            line: 183,
            column: 76
          },
          end: {
            line: 183,
            column: 84
          }
        }],
        line: 183
      },
      "35": {
        loc: {
          start: {
            line: 183,
            column: 86
          },
          end: {
            line: 183,
            column: 102
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 183,
            column: 86
          },
          end: {
            line: 183,
            column: 93
          }
        }, {
          start: {
            line: 183,
            column: 97
          },
          end: {
            line: 183,
            column: 102
          }
        }],
        line: 183
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0,
      "39": 0,
      "40": 0,
      "41": 0,
      "42": 0,
      "43": 0,
      "44": 0,
      "45": 0,
      "46": 0,
      "47": 0,
      "48": 0,
      "49": 0,
      "50": 0,
      "51": 0,
      "52": 0,
      "53": 0,
      "54": 0,
      "55": 0,
      "56": 0,
      "57": 0,
      "58": 0,
      "59": 0,
      "60": 0,
      "61": 0,
      "62": 0,
      "63": 0,
      "64": 0,
      "65": 0,
      "66": 0,
      "67": 0,
      "68": 0,
      "69": 0,
      "70": 0,
      "71": 0,
      "72": 0,
      "73": 0,
      "74": 0,
      "75": 0,
      "76": 0,
      "77": 0,
      "78": 0,
      "79": 0,
      "80": 0,
      "81": 0,
      "82": 0,
      "83": 0,
      "84": 0,
      "85": 0,
      "86": 0,
      "87": 0,
      "88": 0,
      "89": 0,
      "90": 0,
      "91": 0,
      "92": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0
    },
    b: {
      "0": [0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0],
      "9": [0, 0],
      "10": [0, 0],
      "11": [0, 0],
      "12": [0, 0],
      "13": [0, 0],
      "14": [0, 0],
      "15": [0, 0],
      "16": [0, 0],
      "17": [0, 0],
      "18": [0, 0],
      "19": [0, 0],
      "20": [0, 0],
      "21": [0, 0],
      "22": [0, 0],
      "23": [0, 0],
      "24": [0, 0],
      "25": [0, 0],
      "26": [0, 0],
      "27": [0, 0, 0],
      "28": [0, 0],
      "29": [0, 0],
      "30": [0, 0],
      "31": [0, 0],
      "32": [0, 0, 0],
      "33": [0, 0, 0],
      "34": [0, 0],
      "35": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import _classCallCheck from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _objectSpread2 from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
var _jsxFileName = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Form/Form.tsx";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React, { Component } from 'react';
import classnames from 'classnames';
import { getUidStr } from '../utils/uid';
import { formClass } from './styles';
import { FormError } from '../utils/errors';
import { defaultProps } from '../utils/defaultProps';
import { docScroll } from '../utils/dom/document';
import { IGNORE_BIND, SUBMIT_TOPIC } from '../Datum/types';
import { FieldSetProvider } from './FieldSet';
import { isRTL } from '../config';
var emptyValue = (cov_21a5ajomj3.s[0]++, {
  path: ''
});
var DefaultProps = (cov_21a5ajomj3.s[1]++, _objectSpread2(_objectSpread2({}, defaultProps), {}, {
  scrollToError: false,
  throttle: 1000
}));

var Form =
/*#__PURE__*/
function (_Component) {
  _inherits(Form, _Component);

  var _super = _createSuper2(Form);

  function Form(props) {
    var _this;

    _classCallCheck(this, Form);

    cov_21a5ajomj3.f[0]++;
    cov_21a5ajomj3.s[2]++;
    _this = _super.call(this, props);
    _this.locked = void 0;
    _this.id = void 0;
    _this.element = void 0;
    _this.validating = void 0;
    _this.form = void 0;
    cov_21a5ajomj3.s[3]++;
    _this.bindElement = _this.bindElement.bind(_assertThisInitialized(_this));
    cov_21a5ajomj3.s[4]++;
    _this.handleSubmit = _this.handleSubmit.bind(_assertThisInitialized(_this));
    cov_21a5ajomj3.s[5]++;
    _this.handleReset = _this.handleReset.bind(_assertThisInitialized(_this));
    cov_21a5ajomj3.s[6]++;
    _this.locked = false;
    cov_21a5ajomj3.s[7]++;
    _this.id = "form_".concat(getUidStr());
    cov_21a5ajomj3.s[8]++;
    _this.form = {
      getValue: function getValue() {
        cov_21a5ajomj3.f[1]++;
        cov_21a5ajomj3.s[9]++;
        return _this.props.datum.getValue();
      },
      validate: function validate() {
        cov_21a5ajomj3.f[2]++;
        cov_21a5ajomj3.s[10]++;
        return _this.props.datum.validate();
      },
      validateFields: function validateFields(fields) {
        cov_21a5ajomj3.f[3]++;
        cov_21a5ajomj3.s[11]++;
        return _this.props.datum.validateFields(fields)["catch"](function () {
          cov_21a5ajomj3.f[4]++;
        });
      },
      validateFieldsWithError: function validateFieldsWithError(fields) {
        cov_21a5ajomj3.f[5]++;
        cov_21a5ajomj3.s[12]++;
        return _this.props.datum.validateFields(fields);
      },
      clearValidate: function clearValidate() {
        cov_21a5ajomj3.f[6]++;
        cov_21a5ajomj3.s[13]++;

        _this.props.datum.validateClear();
      },
      submit: function submit() {
        var withValidate = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (cov_21a5ajomj3.b[0][0]++, true);
        cov_21a5ajomj3.f[7]++;
        cov_21a5ajomj3.s[14]++;

        if (withValidate) {
          cov_21a5ajomj3.b[1][0]++;
          cov_21a5ajomj3.s[15]++;

          _this.handleSubmit();
        } else {
          cov_21a5ajomj3.b[1][1]++;
          var activeEl = (cov_21a5ajomj3.s[16]++, document.activeElement);
          cov_21a5ajomj3.s[17]++;

          if (activeEl) {
            cov_21a5ajomj3.b[2][0]++;
            cov_21a5ajomj3.s[18]++;
            activeEl.blur();
          } else {
            cov_21a5ajomj3.b[2][1]++;
          }

          cov_21a5ajomj3.s[19]++;

          if (_this.props.onSubmit) {
            cov_21a5ajomj3.b[3][0]++;
            cov_21a5ajomj3.s[20]++;

            _this.props.onSubmit(_this.props.datum.getValue());
          } else {
            cov_21a5ajomj3.b[3][1]++;
          }

          cov_21a5ajomj3.s[21]++;

          if (activeEl) {
            cov_21a5ajomj3.b[4][0]++;
            cov_21a5ajomj3.s[22]++;
            activeEl.focus();
          } else {
            cov_21a5ajomj3.b[4][1]++;
          }
        }
      },
      reset: function reset() {
        cov_21a5ajomj3.f[8]++;
        cov_21a5ajomj3.s[23]++;

        _this.handleReset();
      }
    };
    return _this;
  }

  _createClass(Form, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      cov_21a5ajomj3.f[9]++;

      var _ref = (cov_21a5ajomj3.s[24]++, this.props),
          formRef = _ref.formRef;

      cov_21a5ajomj3.s[25]++;

      if (formRef) {
        cov_21a5ajomj3.b[5][0]++;
        cov_21a5ajomj3.s[26]++;

        if (typeof formRef === 'function') {
          cov_21a5ajomj3.b[6][0]++;
          cov_21a5ajomj3.s[27]++;
          formRef(this.form);
        } else {
          cov_21a5ajomj3.b[6][1]++;
          cov_21a5ajomj3.s[28]++;
          formRef.current = this.form;
        }
      } else {
        cov_21a5ajomj3.b[5][1]++;
      }

      cov_21a5ajomj3.s[29]++;
      this.setStatus();
      cov_21a5ajomj3.s[30]++;

      if (this.element) {
        cov_21a5ajomj3.b[7][0]++;
        cov_21a5ajomj3.s[31]++;
        this.element.addEventListener('submit', this.handleSubmit);
      } else {
        cov_21a5ajomj3.b[7][1]++;
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      cov_21a5ajomj3.f[10]++;
      cov_21a5ajomj3.s[32]++;
      this.setStatus();
      cov_21a5ajomj3.s[33]++;

      if (prevProps.error !== this.props.error) {
        cov_21a5ajomj3.b[8][0]++;
        cov_21a5ajomj3.s[34]++;
        this.props.datum.resetFormError(this.props.error);
      } else {
        cov_21a5ajomj3.b[8][1]++;
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      cov_21a5ajomj3.f[11]++;
      cov_21a5ajomj3.s[35]++;
      this.props.datum.formUnmount = true;
      cov_21a5ajomj3.s[36]++;

      if (this.element) {
        cov_21a5ajomj3.b[9][0]++;
        cov_21a5ajomj3.s[37]++;
        this.element.removeEventListener('submit', this.handleSubmit);
      } else {
        cov_21a5ajomj3.b[9][1]++;
      }
    }
  }, {
    key: "setStatus",
    value: function setStatus() {
      cov_21a5ajomj3.f[12]++;

      var _ref2 = (cov_21a5ajomj3.s[38]++, this.props),
          disabled = _ref2.disabled,
          pending = _ref2.pending,
          setFormStatus = _ref2.setFormStatus;

      cov_21a5ajomj3.s[39]++;

      if (!setFormStatus) {
        cov_21a5ajomj3.b[10][0]++;
        cov_21a5ajomj3.s[40]++;
        return;
      } else {
        cov_21a5ajomj3.b[10][1]++;
      }

      var status = (cov_21a5ajomj3.s[41]++, disabled === true ? (cov_21a5ajomj3.b[11][0]++, 'disabled') : (cov_21a5ajomj3.b[11][1]++, ''));
      cov_21a5ajomj3.s[42]++;

      if (pending === true) {
        cov_21a5ajomj3.b[12][0]++;
        cov_21a5ajomj3.s[43]++;
        status = 'pending';
      } else {
        cov_21a5ajomj3.b[12][1]++;
      }

      cov_21a5ajomj3.s[44]++;
      setFormStatus(status);
    }
  }, {
    key: "bindElement",
    value: function bindElement(el) {
      cov_21a5ajomj3.f[13]++;
      cov_21a5ajomj3.s[45]++;
      this.element = el;
    }
  }, {
    key: "scrollToError",
    value: function scrollToError(err) {
      cov_21a5ajomj3.f[14]++;

      var _ref3 = (cov_21a5ajomj3.s[46]++, this.props),
          scrollToError = _ref3.scrollToError,
          onError = _ref3.onError;

      cov_21a5ajomj3.s[47]++;

      if (scrollToError !== false) {
        cov_21a5ajomj3.b[13][0]++;
        var el = (cov_21a5ajomj3.s[48]++, this.element.querySelector(".".concat(formClass('invalid'))));
        cov_21a5ajomj3.s[49]++;

        if (el) {
          cov_21a5ajomj3.b[14][0]++;
          cov_21a5ajomj3.s[50]++;
          el.scrollIntoView();
          cov_21a5ajomj3.s[51]++;

          if (el.focus) {
            cov_21a5ajomj3.b[15][0]++;
            cov_21a5ajomj3.s[52]++;
            el.focus();
          } else {
            cov_21a5ajomj3.b[15][1]++;
          }
        } else {
          cov_21a5ajomj3.b[14][1]++;
        }

        cov_21a5ajomj3.s[53]++;

        if ((cov_21a5ajomj3.b[17][0]++, typeof scrollToError === 'number') && (cov_21a5ajomj3.b[17][1]++, scrollToError !== 0)) {
          cov_21a5ajomj3.b[16][0]++;
          cov_21a5ajomj3.s[54]++;
          docScroll.top -= scrollToError;
        } else {
          cov_21a5ajomj3.b[16][1]++;
        }
      } else {
        cov_21a5ajomj3.b[13][1]++;
      }

      cov_21a5ajomj3.s[55]++;

      if (onError) {
        cov_21a5ajomj3.b[18][0]++;
        cov_21a5ajomj3.s[56]++;
        onError(err);
      } else {
        cov_21a5ajomj3.b[18][1]++;
      }

      cov_21a5ajomj3.s[57]++;

      if ((cov_21a5ajomj3.b[20][0]++, err instanceof Error) && (cov_21a5ajomj3.b[20][1]++, !(err instanceof FormError))) {
        cov_21a5ajomj3.b[19][0]++;
        cov_21a5ajomj3.s[58]++;
        throw err;
      } else {
        cov_21a5ajomj3.b[19][1]++;
      }
    }
  }, {
    key: "handleSubmit",
    value: function handleSubmit(e) {
      var _this2 = this;

      cov_21a5ajomj3.f[15]++;
      cov_21a5ajomj3.s[59]++;

      if (e) {
        cov_21a5ajomj3.b[21][0]++;
        cov_21a5ajomj3.s[60]++;
        e.preventDefault();
      } else {
        cov_21a5ajomj3.b[21][1]++;
      }

      cov_21a5ajomj3.s[61]++;

      if ((cov_21a5ajomj3.b[23][0]++, e) && (cov_21a5ajomj3.b[23][1]++, e.target.getAttribute('id') !== this.id)) {
        cov_21a5ajomj3.b[22][0]++;
        cov_21a5ajomj3.s[62]++;
        return;
      } else {
        cov_21a5ajomj3.b[22][1]++;
      }

      cov_21a5ajomj3.s[63]++;

      if ((cov_21a5ajomj3.b[25][0]++, this.validating) || (cov_21a5ajomj3.b[25][1]++, this.locked)) {
        cov_21a5ajomj3.b[24][0]++;
        cov_21a5ajomj3.s[64]++;
        return;
      } else {
        cov_21a5ajomj3.b[24][1]++;
      }

      cov_21a5ajomj3.s[65]++;
      this.validating = true; // prevent duplicate submit

      cov_21a5ajomj3.s[66]++;
      this.locked = true;
      cov_21a5ajomj3.s[67]++;
      setTimeout(function () {
        cov_21a5ajomj3.f[16]++;
        cov_21a5ajomj3.s[68]++;
        _this2.locked = false;
      }, this.props.throttle);

      var _ref4 = (cov_21a5ajomj3.s[69]++, this.props),
          datum = _ref4.datum,
          onSubmit = _ref4.onSubmit;

      var activeEl = (cov_21a5ajomj3.s[70]++, document.activeElement);
      cov_21a5ajomj3.s[71]++;

      if (activeEl) {
        cov_21a5ajomj3.b[26][0]++;
        cov_21a5ajomj3.s[72]++;
        activeEl.blur();
      } else {
        cov_21a5ajomj3.b[26][1]++;
      }

      cov_21a5ajomj3.s[73]++;
      datum.dispatch(SUBMIT_TOPIC);
      cov_21a5ajomj3.s[74]++;
      setTimeout(function () {
        cov_21a5ajomj3.f[17]++;
        cov_21a5ajomj3.s[75]++;
        datum.validate(IGNORE_BIND).then(function () {
          cov_21a5ajomj3.f[18]++;
          cov_21a5ajomj3.s[76]++;
          _this2.validating = false; // @ts-ignore

          var detail = (cov_21a5ajomj3.s[77]++, (cov_21a5ajomj3.b[27][0]++, e) && (cov_21a5ajomj3.b[27][1]++, e.nativeEvent) && (cov_21a5ajomj3.b[27][2]++, e.nativeEvent.detail));
          cov_21a5ajomj3.s[78]++;

          if (onSubmit) {
            cov_21a5ajomj3.b[28][0]++;
            cov_21a5ajomj3.s[79]++;
            onSubmit(datum.getValue(), detail, e);
          } else {
            cov_21a5ajomj3.b[28][1]++;
          }

          cov_21a5ajomj3.s[80]++;

          if (activeEl) {
            cov_21a5ajomj3.b[29][0]++;
            cov_21a5ajomj3.s[81]++;
            activeEl.focus();
          } else {
            cov_21a5ajomj3.b[29][1]++;
          }
        })["catch"](function (err) {
          cov_21a5ajomj3.f[19]++;
          cov_21a5ajomj3.s[82]++;
          _this2.validating = false; // wait for render complete

          cov_21a5ajomj3.s[83]++;
          setTimeout(_this2.scrollToError.bind(_this2, err));
        });
      }, 10);
    }
  }, {
    key: "handleReset",
    value: function handleReset() {
      cov_21a5ajomj3.f[20]++;

      var _ref5 = (cov_21a5ajomj3.s[84]++, this.props),
          datum = _ref5.datum,
          onReset = _ref5.onReset;

      cov_21a5ajomj3.s[85]++;
      datum.reset();
      cov_21a5ajomj3.s[86]++;

      if (onReset) {
        cov_21a5ajomj3.b[30][0]++;
        cov_21a5ajomj3.s[87]++;
        onReset();
      } else {
        cov_21a5ajomj3.b[30][1]++;
      }
    }
  }, {
    key: "render",
    value: function render() {
      cov_21a5ajomj3.f[21]++;

      var _ref6 = (cov_21a5ajomj3.s[88]++, this.props),
          layout = _ref6.layout,
          style = _ref6.style,
          inline = _ref6.inline,
          disabled = _ref6.disabled,
          datum = _ref6.datum,
          rules = _ref6.rules,
          pending = _ref6.pending;

      cov_21a5ajomj3.s[89]++;

      if ((cov_21a5ajomj3.b[32][0]++, datum) && (cov_21a5ajomj3.b[32][1]++, rules) && (cov_21a5ajomj3.b[32][2]++, datum.rules !== rules)) {
        cov_21a5ajomj3.b[31][0]++;
        cov_21a5ajomj3.s[90]++;
        datum.rules = rules;
      } else {
        cov_21a5ajomj3.b[31][1]++;
      }

      var className = (cov_21a5ajomj3.s[91]++, classnames(formClass('_', layout, ((cov_21a5ajomj3.b[33][0]++, disabled) || (cov_21a5ajomj3.b[33][1]++, pending)) && (cov_21a5ajomj3.b[33][2]++, 'disabled'), (cov_21a5ajomj3.b[34][0]++, inline) && (cov_21a5ajomj3.b[34][1]++, 'inline'), (cov_21a5ajomj3.b[35][0]++, isRTL()) && (cov_21a5ajomj3.b[35][1]++, 'rtl')), this.props.className));
      cov_21a5ajomj3.s[92]++;
      return (
        /*#__PURE__*/
        React.createElement("form", {
          ref: this.bindElement,
          className: className,
          id: this.id,
          style: style,
          onReset: this.handleReset,
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 188,
            columnNumber: 7
          }
        },
        /*#__PURE__*/
        React.createElement(FieldSetProvider, {
          value: emptyValue,
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 189,
            columnNumber: 9
          }
        }, this.props.children))
      );
    }
  }]);

  return Form;
}(Component);

Form.defaultProps = DefaultProps;
export default Form;